
  import {Component, Prop, Vue} from "vue-property-decorator";
  import VoucherService from "../../../services/voucher.service"
  import LoadingOverlay from "../../core/LoadingOverlay.vue";
  import {Voucher} from "../../../models/voucherI";

  @Component({
    components: {LoadingOverlay},
  })
  export default class ApproveDialog extends Vue {

    @Prop({default: null})
    param: any;

    @Prop({default: false})
    multipleApproval: boolean;

    @Prop({default: false})
    isMohtamimMuhasibApproval: boolean;

    private approvalComment = "";

    private showOverlay = false;

    private maxTwoHundred =  [
      (v: string) => /^.{0,200}$/.test(v) || 'Maximal '+ 200 + ' Zeichen'
    ];

    approveVoucher() {
      this.showOverlay = true;
        let data = {
          voucher: this.param.voucher,
          vendorId: this.param.vendorId,
          claimentVendorId: this.param.claimentVendorId,
          voucherAttachments: this.param.voucherAttachments,
          approvalComment: this.approvalComment
        }

        for (var i = 0; i < data.voucher.voucherCostsSet.length; i++) {
          //this needs do be done for database:
          //@ts-ignore
          data.voucher.voucherCostsSet[i].amount = data.voucher.voucherCostsSet[i].amount.toString().replace(",", ".")
        }

        if (data.voucher.advanceAmount) {
          data.voucher.advanceAmount = data.voucher.advanceAmount.toString().replace(",", ".")
        }

        VoucherService.approveVoucher(data)
        .then(
          (response: any) => {
            this.$notify({
              group: 'foo',
              title: 'Info',
              text: response.data,
              type: 'success'
            });
            this.showOverlay = false;
            (this.$refs.form as Vue & { reset: () => boolean }).reset();
            this.$emit('event');
          })
        .catch((error: any) => {
          this.$notify({
            group: 'foo',
            title: 'Fehler',
            text: error.response.data,
            type: 'error'
          });
          this.showOverlay = false;
        })
        .finally(() => {
          setTimeout(() => {
            this.showOverlay = false;
          }, 5000);
        });
    }

  }
